import React from 'react';
import { Text, View } from 'react-native';
import Translation from '../../../../../Common/DTO/Translation';
import Helpers from '../../../../../Common/Helpers/AmountHelpers';
import { TranslationView } from '@levelapp/softfabric-ui';
import { styles } from './AboutViewStyle';


interface AboutViewProps {
  projectAbout : Translation;
}

export const AboutView = ({projectAbout}:AboutViewProps) => {

    return (
        <View style={styles.page}>
            <TranslationView style={styles.title}>about.title</TranslationView>
            <Text style={styles.text}>{Helpers.getCorrectTranslation(projectAbout)}</Text>
        </View>
    );
}